<div class="mbs-steps">
  <ng-content />
</div>
